// eslint-disable-next-line import/no-cycle
import { MediaAPI } from '@/api';
import WpPost from '@/interfaces/wp/WpPost';
import axios from 'axios';
import { env } from '@/helpers';

class BlogAPI {
  static get(
    perPage = 10,
    page = 1,
    categories: number[] = [],
    order: 'desc' | 'asc' = 'desc',
    orderby: 'date' | 'modified' | 'title' | 'id' | 'author' | 'include' | 'parent' | 'relevance' | 'slug' | 'include_slugs' = 'date',
  ): Promise<{
    totalCount: number,
    totalPages: number,
    count: number,
    posts: WpPost[],
  }> {
    const apiResponse = {
      totalCount: 0,
      totalPages: 0,
      count: 0,
      posts: [] as WpPost[],
    };
    return new Promise((resolve, reject) => {
      axios.get<WpPost[]>(`${env('API_BASE_PATH')}posts`, {
        params: {
          per_page: perPage,
          page,
          order,
          orderby,
          context: 'embed',
          categories: categories.length ? categories : undefined,
        },
      }).then((response) => {
        const posts = (response.data || []) as WpPost[];
        apiResponse.count = posts.length;
        apiResponse.totalCount = parseInt(response.headers['x-wp-total'] || `${posts.length}`, 10);
        apiResponse.totalPages = parseInt(response.headers['x-wp-totalpages'] || '1', 10);

        const mediaIds: number[] = [];
        posts.forEach((post) => {
          if (post.featured_media && !mediaIds.includes(post.featured_media)) {
            mediaIds.push(post.featured_media);
          }
        });

        MediaAPI.get(mediaIds).then((mediaPosts) => {
          apiResponse.posts = posts.map((post) => ({
            ...post,
            postMedia: mediaPosts.find((mediaPost) => mediaPost.id === post.featured_media),
          }));

          resolve(apiResponse);
        });
      }).catch((e) => {
        const pageResponse = e?.response?.data;

        if (pageResponse) {
          resolve(pageResponse);
        } else {
          reject(e);
        }
      });
    });
  }

  static getCategories(): Promise<Array<{
    id: number,
    name: string,
    slug: string,
  }>> {
    return new Promise((resolve, reject) => {
      axios.get(`${env('API_BASE_PATH')}categories`, {
        params: {
          per_page: 100,
          context: 'embed',
        },
      }).then((response) => {
        resolve((response.data || []).map((el: any) => ({
          id: el.id,
          name: el.name,
          slug: el.slug,
        })));
      }).catch((e) => {
        reject(e);
      });
    });
  }
}

export default BlogAPI;
